export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/email_marketing.9b54bd9.svg";